import utils, {axiosWithAuth} from '@imt/vue-toolbox/src/utils';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const authedAxios = axiosWithAuth('');

export const actions = {
    async createActivity(_, {url = '', system, action, modelId, additional, userId}) {
        if (['development', 'test'].includes(process.env.NODE_ENV)) {
            return;
        }

        const response = await authedAxios.post(
            `${url}/api/v1/activity/`,
            utils.dataFormatter.serialize({
                stuff: {system, action, modelId, additional, user: {id: userId, type: 'User'}, type: 'Activity'},
            }),
        );

        return utils.dataFormatter.deserialize(response.data);
    },
    async listActivity(context, {url = '', filters = {}, limit = null}) {
        url += '/api/v1/activity/?include=user';

        if (Object.keys(filters).length) {
            url += `${Object.keys(filters).map((key) => {
                return `&filter[${key}]=${filters[key]}`;
            }).join('')}`;
        }

        if (limit) {
            url += `&page[size]=${limit}`;
        }

        const response = await authedAxios.get(url);

        context.commit('SET_ACTIVITY', utils.dataFormatter.deserialize(response.data));

        return utils.dataFormatter.deserialize(response.data);
    },
};

export const mutations = {
    SET_ACTIVITY(state, activity) {
        state.activity = activity;
    },
};

export const state = () => {
    return {
        activity: [],
    };
};

const activityModule = {
    namespaced: true,
    state: state(),
    mutations,
    actions,
};

export const store = new Vuex.Store(activityModule);

export default activityModule;
